import { BaseComponent } from './baseComponent';

export class Tabs extends BaseComponent {
    private titles: NodeListOf<HTMLElement>;
    private tabs: NodeListOf<HTMLElement>;

    // no options for js yet...
    constructor(container: HTMLElement, options: Record<string, any>) {
        super(container, options);

        this.titles = this.container.querySelectorAll('.tab-title');
        this.titles.forEach(title => {
            title.addEventListener('keydown', this.handleKeydown.bind(this));
        });

        this.tabs = this.container.querySelectorAll('.tab-content');
        this.tabs.forEach(tab => {
            document.querySelectorAll(`[href="#${tab.id}"], [data-href="#${tab.id}"]`).forEach(linkTrigger => {
                linkTrigger.addEventListener('click', (event: Event): void => {
                    event.preventDefault();
                    this.open(tab);
                });
            });

            tab.addEventListener('open', (event: Event): void => {
                this.open(tab);
            });
        });
        this.onLoad();
    }

    handleKeydown(event: KeyboardEvent) {
        const target = event.currentTarget;
        if (!(target instanceof Element)) return;
        const first = this.titles[0];
        const last = this.titles[this.titles.length - 1];
        let title;

        switch (event.key) {
            case 'ArrowLeft':
                title = (target.closest('li').previousElementSibling)
                    ? target.closest('li').previousElementSibling.querySelector('a')
                    : last;
                break;

            case 'ArrowRight':
                title = (target.closest('li').nextElementSibling)
                    ? target.closest('li').nextElementSibling.querySelector('a')
                    : first;
                break;

            case 'Home':
                title = first;
                break;

            case 'End':
                title = last;
                break;
        }
        if (title) this.handleChange(title);
    }

    handleChange(title: HTMLElement) {
        // timeout needed for some browsers
        setTimeout(() => {
            title.focus();
        }, 10)

        if (title.closest('li').classList.contains('is-active')) return;

        this.open(this.container.querySelector(title.href));
    }

    open(content: HTMLElement) {
        const prevActiveTitle = this.container.querySelector('.tabs .is-active a');
        const prevActiveContent = this.container.querySelector('.tab-content.is-active');
        const title = this.container.querySelector(`.tab-title[href="#${content.id}"]`)

        prevActiveTitle.closest('li').classList.remove('is-active');
        prevActiveTitle.setAttribute('aria-selected', 'false');
        prevActiveTitle.setAttribute('tabindex', '-1');

        prevActiveContent.classList.remove('is-active');
        prevActiveContent.setAttribute('inert', 'true');

        title.closest('li').classList.add('is-active');
        title.setAttribute('aria-selected', 'true');
        title.setAttribute('tabindex', '0');

        content.classList.add('is-active');
        content.removeAttribute('inert');

        this.afterOpen(content.id);
    }

    public getDefaultOptions(options: Record<string, any> = {}) {
        const defaultOptions = {};
        return {
            ...super.getDefaultOptions(),
            ...defaultOptions,
            ...options,
        };
    }
}
